module.exports = __webpack_public_path__ + "Roboto-Italic.woff?6521f388081e84791dba294c9e7cfb4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Italic/Roboto-Italic.woff?v=2.137
// module id = 194
// module chunks = 7